import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles, shorthands, SkeletonItem } from '@fluentui/react-components';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    ...shorthands.gap('8px'),
  },
});

export const LabelSkeletonItem = ({ width }) => {
  const classes = useStyles();

  return (
    <div className={classes.row} style={{ width }}>
      <SkeletonItem size={16} />
    </div>
  );
};

LabelSkeletonItem.propTypes = {
  width: PropTypes.number,
};

LabelSkeletonItem.defaultProps = {
  width: 250,
};

export const RadioSkeletonItem = ({ width }) => {
  const classes = useStyles();

  return (
    <div className={classes.row}>
      <SkeletonItem size={24} shape="circle" />
      <div style={{ width }} >
        <SkeletonItem size={16} />
      </div>
    </div>
  );
};

RadioSkeletonItem.propTypes = {
  width: PropTypes.number,
};

RadioSkeletonItem.defaultProps = {
  width: 250,
};

export const DropdownSkeletonItem = ({ width }) => {
  const classes = useStyles();

  return (
    <div className={classes.row} style={{ width }}>
      <SkeletonItem size={32} />
    </div>
  );
};

DropdownSkeletonItem.propTypes = {
  width: PropTypes.number,
};

DropdownSkeletonItem.defaultProps = {
  width: 250,
};
